// src/components/AttendanceFilters.js
import React, { useState, useEffect } from "react";
import { CardContent, Typography, Stack, CardHeader } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import { countries } from "countries-list";
import { addMonths, getDaysInMonth } from "date-fns";
import { useUserDetails } from "../../../context/auth";
import AttendanceTable from "./AttendanceTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { valid } from "chroma-js";
function AttendanceFilters() {
  const {
    totaldays,
    settotaldays,
    setallyears,
    setallmonth,
    setfromdate,
    setenddate,
    allyears,
    allmonth,
    fromdate,
    enddate,
    loaction,
    setLocation,
    setDepartment,
    department,
    employee,
    setEmployee,
    setShifts,
    shifts,
    AccessData,
  } = useUserDetails();
  console.log(AccessData,"AccessData");
  
  const countryOptions = Object.entries(countries).map(([code, country]) => ({
    value: code,
    label: country.name,
  }));
  console.log(countryOptions);

  const [selectedCountry, setSelectedCountry] = useState({
    value: "IN",
    label: "India",
  });

  const navigate = useNavigate();
  // const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth(); // 0-indexed (0 = January, 11 = December)

  const currentYear = new Date().getFullYear();
  console.log(currentYear, "currentYear");

  const startYear = 2000;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  const yearOptions = years.map((year) => ({
    value: year,
    label: year.toString(),
  }));

  // Generate month options
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // const monthOptions = monthNames.map((month, index) => ({
  //   value: index,
  //   label: month,
  // }));
  const currentMonths = new Date().getMonth();

  // State to manage selected year and month
  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });
  const [selectedMonth, setSelectedMonth] = useState({
    value: currentMonth,
    label: monthNames[currentMonth],
  });
  const monthOptions = () => {
    let month;
    if (selectedYear?.value) {
      if (currentYear == selectedYear?.value) {
        month = monthNames.slice(0, currentMonths + 1).map((month, index) => ({
          value: index,
          label: month,
        }));
      } else {
        month = monthNames.map((month, index) => ({
          value: index,
          label: month,
        }));
      }
    } else {
      month = monthNames.map((month, index) => ({
        value: index,
        label: month,
      }));
    }
    return month;
  };

  const [fromDate, setFromDate] = useState("");
  const [tillDate, setTillDate] = useState("");
  const [emplye, setEmlye] = useState("");
  const [shift, setShift] = useState("");
  const [depart, setDepart] = useState("");

  const [departmentList, setDepartmentList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeFilterList, setEmployeeFilterList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  console.log(fromDate, tillDate, departmentList, shiftList, "date");

  const currentDate = new Date();
  useEffect(() => {
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    // Selected year and month
    const year = selectedYear.value;
    const month = selectedMonth.value;

    // First day of the selected month
    const startOfMonth = new Date(year, month, 1);

    // If the selected month is the current month, set tillDate as today; otherwise, set it as the last day of the selected month
    const endOfMonth =
      year === currentYear && month === currentMonth
        ? currentDate
        : new Date(year, month + 1, 0); // Last day of the month

    // Format dates as YYYY-MM-DD in local timezone
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setFromDate(formatDate(startOfMonth));
    setTillDate(formatDate(endOfMonth));
  }, [selectedMonth, selectedYear]);

  const formatDate = (year, month, day) => {
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const onDepartmentSubmit = async () => {
    const query = `query {  
        allDepartment {
            id
            departmentName
            departmentCode
        }
    }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract department data from the response
      const departmentList = response.data.data.allDepartment;
      setDepartmentList(departmentList);
      // setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const onShiftDetails = async () => {
    const query = `
   query allShifts{
allShifts {
  data{
    id
name
startTime
endTime
}

}
}
    `;
    try {
      // setPageState((prev) => ({ ...prev, loading: true }));

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const shiftData = response.data?.data?.allShifts?.data; // Adjusted field name
      if (shiftData) {
        setShiftList(shiftData);
        // setPageState((prev) => ({ ...prev, loading: false, state: 'success' }));
      } else {
        console.error("Error: Shift data not found in response.");
      }
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };
  const userDetails = sessionStorage.getItem("user");
  const parsedData = JSON.parse(userDetails);
  const encodedId = parsedData?.id;
  const onEmployeeeSubmit = async () => { 
    const managerQuery = AccessData?.some(
      (item) =>
        item.module === "Attendance" &&
        item.component === "ManagerAttendance" &&
        item.can_access
    );

    const hrQuery = AccessData?.some(
      (item) =>
        item.module === "Attendance" &&
        item.component === "HRAttendance" &&
        item.can_access
    );
    //if neither managerQuery nor hrQuery is true, log an error and return
    if(!managerQuery && !hrQuery) {
      console.error("Access Denied: No valid access for Attendance module.");
      return;
    }
    const query =
    //if managerQuery is true and hrQuery is false, use manager query, else all query
      (managerQuery && !hrQuery)
        ? `query($id: String!){
            manager(teamleaderId: $id){
              empid
              id
              firstName
              lastName
              department
            }
          }`
        : `query activeUsersDetail{
            activeUsersDetail {
              id
              lastLogin
              username
              firstName
              lastName
              isSuperuser
              isActive
              dateJoined
              email
              salutation
              dateOfBirth
              contactNumber
              emergencyContact
              gender
              employeeType
              lastUpdate
              department
              designation
              empid
              teamleader
              grade
            }
          }`;


    try {
      // setPageState({ ...pageState, loading: true });
      if (managerQuery && !hrQuery) {
        const response = await axios.post(
          BASEURL,
          {
            query: query,

            variables: {
              id:  encodedId,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response?.data?.data?.manager, "reps");
        setEmployeeFilterList(response?.data?.data?.manager);
        setEmployeeList(response?.data?.data?.manager);
      } else {
        const response = await axios.post(
          BASEURL,
          {
            query: query,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const activeUsers = (response?.data?.data?.activeUsersDetail || []).filter(
          (user) => (user.isSuperuser) === false
        );

        setEmployeeList(activeUsers);
        setEmployeeFilterList(activeUsers);
      }
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };
  console.log(currentMonths, selectedYear, "currentMonths");
  const filter = () => {
    if (depart) {
      const temp = employeeFilterList?.filter(
        (item) => item?.department === depart?.value
      );

      setEmployeeList(temp);
    }
  };

  useEffect(() => {
    filter();
  }, [depart]);

  useEffect(() => {
    onDepartmentSubmit();
    onShiftDetails();
    onEmployeeeSubmit();
  }, []);
  useEffect(() => {
    if (selectedYear && selectedMonth) {
      const firstDate = formatDate(selectedYear.value, selectedMonth.value, 1);
      // setFromDate(firstDate);
      // setfromdate(firstDate);
      setallyears(selectedYear);
      setallmonth(selectedMonth);
      setLocation(selectedCountry);
      setfromdate(fromDate);
      setenddate(tillDate);
      setShifts(shift);
      setDepartment(depart);
      setEmployee(emplye);
      const lastDay = getDaysInMonth(
        new Date(selectedYear.value, selectedMonth.value)
      );

      settotaldays(lastDay);
      const lastDate = formatDate(
        selectedYear.value,
        selectedMonth.value,
        lastDay
      );
      // setenddate(lastDate);
      // setTillDate(lastDate);
    }
  }, [
    selectedYear,
    selectedMonth,
    selectedCountry,
    fromDate,
    tillDate,
    shift,
    depart,
    emplye,
    totaldays,
  ]);
  console.log(totaldays, "totaldays");

  const handleFromDateChange = (event) => {
    const selectedDate = event.target.value;
    setFromDate(selectedDate);

    if (tillDate < selectedDate) {
      setTillDate(selectedDate);
    }
  };

  // Handle change in the 'Till' date
  const handleTillDateChange = (event) => {
    setTillDate(event.target.value);
  };

  const handleOnclick = () => {
    navigate("/attendance/approvals");
  };

  const onChangeHandelar = (event, type) => {
    console.log(event, type, "type");
    if (type == "loaction") {
      setSelectedCountry(event);
    } else if (type == "shift") {
      setShift(event);
    } else if (type == "department") {
      setDepart(event);
    } else {
      setEmlye(event);
    }
  };
  console.log(monthOptions(), "AccessData");

  return (
    <div
      style={{
        zIndex: 2,
        padding: "10px 0px",
      }}
    >
      <CardContent>
        <MaterialBox>
   
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Attendance
                  </MaterialTypography>
                </Stack>

                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => handleOnclick()}
                >
                  Approvals
                </MaterialButton>
              </Stack>
            }
          ></CardHeader>

          <Grid container spacing={2}>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Location
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="location"
                customStyles={{ optionPadding: 20 }}
                value={selectedCountry}
                onChange={(e) => onChangeHandelar(e, "loaction")}
                options={countryOptions.map((item) => {
                  return {
                    value: item?.value,
                    label: item?.label,
                  };
                })}
                // isClearable
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Year
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="year"
                options={yearOptions}
                value={selectedYear}
                onChange={(year) => setSelectedYear(year)}
                customStyles={{ optionPadding: 20 }}
                // isClearable
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Month
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="month"
                options={monthOptions()}
                value={selectedMonth}
                onChange={(month) => setSelectedMonth(month)}
                customStyles={{ optionPadding: 20 }}

                // isClearable
                //  isDisabled={!isMonthEnabled}
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  From
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="fromDate"
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
                // min={formatDate(selectedYear?.value, selectedMonth?.value, 1)} // Minimum is the 1st date of the month
              />
            </Grid>

            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Till
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="tillDate"
                type="date"
                value={tillDate}
                onChange={handleTillDateChange}
                // min={fromDate} // Minimum is the selected 'From' date
                // max={formatDate(
                //   selectedYear?.value,
                //   selectedMonth?.value,
                //   getDaysInMonth(
                //     new Date(selectedYear.value, selectedMonth.value)
                //   )
                // )} // Maximum is the last date of the month
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Department
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="leaveType"
                value={depart}
                customStyles={{ optionPadding: 10 }}
                onChange={(e) => onChangeHandelar(e, "department")}
                options={departmentList?.map((item) => {
                  return {
                    value: item?.departmentName,
                    label: item?.departmentName,
                  };
                })}
                isClearable
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="leaveType"
                value={emplye}
                customStyles={{ optionPadding: 20 }}
                onChange={(e) => onChangeHandelar(e, "emplyo")}
                options={employeeList?.map((item) => {
                  return {
                    value: item?.empid,
                    label: item?.firstName + " " + item?.lastName,
                  };
                })}
                isClearable
              />
            </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Shifts
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="leaveType"
                value={shift}
                customStyles={{ optionPadding: 20 }}
                onChange={(e) => onChangeHandelar(e, "shift")}
                options={shiftList?.map((item) => {
                  return {
                    value: item?.name,
                    label: item?.name,
                  };
                })}
                isClearable
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
    </div>
  );
}

export default AttendanceFilters;
